import type { SubmissionStatus } from '../ResultsPage/types';
import type {
  Question,
  ResultsPageExitStrategyExtraCtaConfig,
} from '../../types/types';
import type { Result } from '../../types/result';

export enum RecommenderStep {
  PROGRAM_SELECT = 'PROGRAM_SELECT',
  PII_CONFIRMATION = 'PII_CONFIRMATION',
  ADDITIONAL_QUESTIONS = 'ADDITIONAL_QUESTIONS',
  EXIT_STRATEGY = 'EXIT_STRATEGY',
  SUBMISSION = 'SUBMISSION',
}

export type RecommenderProps = {
  step: RecommenderStep;
  results?: Result[];
  selectedResult?: Result;
  startTime?: number;
  onCloseExperience?: () => void;
  onBackButtonClick?: () => void;
  onProgramClick: (result: Result) => void;
  onProgramSubmit: (formData?: any) => void;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  setFirstName: (value: string) => void;
  setLastName: (value: string) => void;
  setEmail: (value: string) => void;
  setPhone: (value: string) => void;
  formErrors: { field: string }[];
  setFormErrors: (errors: { field: string }[]) => void;
  canSubmit?: boolean;
  isLoading?: boolean;
  piiLeadErrors: { field: string }[];
  leadSubmissionStatus?: SubmissionStatus;
  setLeadSubmissionStatus: (status: SubmissionStatus) => void;
  productClickedCorrelationId?: string;
  questions?: Question[];
  editMode?: boolean;
  setEditMode?: (mode: boolean) => void;
  submittedResults?: { programId?: number; schoolId?: string }[];
  /**
   * Generic partner identifiers read off the LDS v4 submit response
   * (EDUN-14483), e.g. `{ referenceId, studentId }`. Forwarded to the
   * `EXIT_STRATEGY` step's CTA interpolation sources alongside `lead` so
   * `applicationCta`/`postLeadCta` fieldMap entries like
   * `partnerIdentifiers.studentId` can resolve. Absent before the lead is
   * submitted.
   */
  partnerIdentifiers?: Record<string, string>;
  extraCtaConfig?: ResultsPageExitStrategyExtraCtaConfig;
};
